import styled from "styled-components";
import { Table } from "antd";

import { mediaQueries } from "../../styles/media-queries";
import { theme } from './../../styles/theme-playsports';


import "antd/lib/table/style";

const ContainerStyle = styled.div`
    
`;

const SelectGroupStyle = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 10px;

    > div {
        margin: 5px 0;
    }

    @media ${mediaQueries.tablet} {
        flex-wrap: nowrap;
        justify-content: space-between;

        > div {
            margin: 0 5px;
        }
    }
`;

const tablePagination = `
.ant-pagination {
    width: 100%;
    text-align: center;

    .ant-pagination-prev, .ant-pagination-next {
        a {
            border-radius: 0px;
        }

        &:hover:not(.ant-pagination-disabled) a {
            color: white;
        }
    }

    .ant-pagination-item {
        border-radius: 0px;

        &:hover:not(.ant-pagination-disabled), &.ant-pagination-item-active {

            a {
                font-weight: bold;
                color: #121212;
            }
        }
    }

    .ant-pagination-disabled {
        a {
            font-weight: bold;
            color: #ababab;
        }
    }
}
`;

const TableStyle = styled(Table)`
    .ant-table {
        color: #000;
    }

    .ant-table-thead {
        th {
            padding-top: 10px;
            padding-bottom: 10px;
            background: #151820;
            color: #FFF;
        }
    }

    .avatar-container {
        margin-bottom: -10px;
    }

    .ant-table-tbody {
        .ant-table-row {
            background-color: #FFF;
            > td {
                border: none;
                padding: 7.5px;

                &:first-child {
                    padding: 2.5px 10px 0 15px;
                }
            }

            &--odd {
                background-color: #fff;
            }
        }

        .cursor-pointer {
            cursor: pointer;
        }
    
        .ant-table-row--odd {
            background-color: rgb(244, 244, 244)
        }
    }

    ${tablePagination}  
` as any;

const CalendarTableStyle = styled(Table)`
    .ant-table {
        color: #000;
    }

    .ant-table-thead {
        th {
            padding-top: 10px;
            padding-bottom: 10px;
            background: #151820;
            color: #FFF;
        }
    }

    .avatar-container {
        margin-bottom: -10px;
    }

    .ant-table-tbody {
        .ant-table-row {
            border: 1px solid #000;

            background-color: #FFF;
            > td {
                padding: 7.5px;

                &:first-child {
                    padding: 2.5px 10px 0 15px;
                }
            }

            &--odd {
                background-color: #fff;
            }
        }

        .cursor-pointer {
            cursor: pointer;
        }
    }

    ${tablePagination}  
` as any;

const BasicTableStyle = styled(Table)`
    .ant-table {
        color: #151820;
    }

    .ant-table-content {
        overflow-x: scroll;
    }


    a,
    a:visited {
        color: #151820;
    }



    .ant-table-thead {
        th {
            padding-top: 10px;
            padding-bottom: 10px;
            background: #151820;
            color: #FFF;
            padding: 7.5px;
            &:last-child {
                text-align: right;
            }
        
        }

        > tr { 
            &:first-child, :last-child { 
                > th {
                    border: 0;
                    &:first-child, :last-child {
                        border-radius: 0;
                    }
                }
            }
        }
    }


    .ant-table-tbody {
        .ant-table-row {
            background-color: #FFF;
            > td {
                padding: 7.5px;
                &:last-child {
                    text-align: right;
                }
            }

            &--odd {
                background-color: #fff;
            }
        }

        .cursor-pointer {
            cursor: pointer;
        }
    }

    ${tablePagination}
` as any;

const PlayerStyle = styled.div`
    ${(props: any) =>
        props.type === "desktop" &&
        `
        display: none;
    `}
    
    @media ${mediaQueries.mobileL} {
        ${(props: any) =>
        props.type === "desktop" &&
        `
            display: block;
        `}
    }

    .name {
        font-size: 0.9rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 150px;
    }

    .mobile-name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 120px;
    }

    ${(props: any) =>
        props.type === "mobile" &&
        `
        display: block;
    `}

    @media ${mediaQueries.mobileL} {
        ${(props: any) =>
        props.type === "mobile" &&
        `
            display: none;
        `}
    }

    p {
        margin-bottom: 0;

        &:first-child {
            font-weight: bold;
        }
    }
` as any;

export {
    ContainerStyle,
    SelectGroupStyle,
    PlayerStyle,
    TableStyle,
    CalendarTableStyle,
    BasicTableStyle
};

